import http from '@/assets/js/common/http-common';

class QuestionDataService {
  
  list() {
    return http.post('questao/list', null);
  }

  listAll() {
    return http.post('questao/listAll', null);
  }

  deleteFromRepository(data) {
    return http.post('questao/deleteFromRepository', data);
  }

  create(data) {
    return http.post('questao/create', data);
  }

  read(id) {
    return http.post('questao/read', {id:id});
  }
  
  update(data) {
    return http.post('questao/update', data);
  }
  
  delete(id) {
    return http.post('questao/delete', {id:id});
  }
  
}

export default new QuestionDataService();
